// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606250142/js/" + chunkId + "." + {"44":"ea8dd8bc","225":"01a45eee","481":"78df25a1","486":"858d379b","770":"a4bcbcad"}[chunkId] + ".0.36362985522597435.chunk.js";
};